/* eslint-disable react/destructuring-assignment */
/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';

import { toggleOverlay } from 'actions/overlay';
import { OVERLAY_TYPES } from 'constants/constants';
import routes from 'constants/routes';
import { ContractExpiryIcon } from 'styles/assets/icons';
import { Overlay } from 'UIKit';

import Modal from '../modal';
import styles from './index.module.scss';

const ContractExpiry = props => {
  const history = useHistory();
  const dispatch = useDispatch();

  const onBackToTradingClick = () => {
    history.push(`${routes.default}${props.contract_type}/trade/}`);
    dispatch(
      toggleOverlay({
        overlayType: OVERLAY_TYPES.CONTRACT_DROPDOWN,
        value: false,
      })
    );
  };

  return (
    <>
      <Modal isOpen onRequestClose={() => {}}>
        <div className={styles.container}>
          <div className={styles.icon}>
            <ContractExpiryIcon />
          </div>
          <div className={styles.text}>This contract has expired</div>
          <div className={styles[`button-area`]}>
            <button
              data-testid="p9g33DNRHrqYUAynFG_e6"
              type="button"
              className={styles.button}
              onClick={onBackToTradingClick}
            >
              Back to trading
            </button>
            <button
              data-testid="8NPRY_ny8Cj14eZQGpfgC"
              type="button"
              className={styles.button}
              onClick={() => history.push(`${routes.expired_futures_and_options}`)}
            >
              See expired contracts
            </button>
          </div>
        </div>
      </Modal>
      <Overlay />
    </>
  );
};

export default ContractExpiry;
